export default __webpack_public_path__ + "images/J8.7ac719f.png";